var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { padding: "0 50px 32px 0" } },
    [
      _c("h4", { style: { marginBottom: "20px" } }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _c(
        "v-chart",
        {
          attrs: {
            forceFit: true,
            height: _vm.height,
            data: _vm.data,
            scale: _vm.scale,
            padding: _vm.padding,
            onClick: _vm.handleClick,
          },
        },
        [
          _c("v-tooltip"),
          _c("v-legend"),
          _c("v-axis"),
          _c("v-bar", { attrs: { position: "type*bar" } }),
          _c("v-line", {
            attrs: { position: "type*line", color: "#2fc25b", size: 3 },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }